<template>
  <div class="meeting-container">
    <div class="meeting-description">
      <h2>Meeting Topic: {{ meeting.topic }}</h2>
      <p>Student: {{ meeting.student }}</p>
      <p>Date: {{ meeting.date }}</p>
      <p>Time: {{ meeting.time }}</p>
      <p>Zoom Link: {{ meeting.link }}</p>
    </div>
    <div class="buttons-container">
      <button @click="acceptMeeting" class="accept-button">Accept</button>
      <button @click="declineMeeting" class="decline-button">Decline</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // Placeholder data for the meeting
      meeting: {
        Topic: "", // Fill in the topic
        Student: "",
        Date: "", // Fill in the date
        Time: "", // Fill in the time
        ZoomLink: "", // Fill in location
      },
    };
  },
  methods: {
    acceptMeeting() {
      alert('Meeting Accepted');
      // Implement your logic for accepting a meeting here
    },
    declineMeeting() {
      alert('Meeting Declined');
      // Implement your logic for declining a meeting here
    },
  },
};
</script>

<style>
.meeting-container {
  text-align: center;
}

.meeting-description {
  margin-bottom: 20px;
}

.buttons-container {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.accept-button, .decline-button {
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
}

.accept-button {
  background-color: #4CAF50; /* Green */
}

.decline-button {
  background-color: #f44336; /* Red */
}
</style>
